import type React from 'react';
import { useEffect, useRef } from 'react';

import { TrackAction, TrackActionSubject } from './new-analytics-types';

import { useAnalyticsClient } from './use-analytics-client';

export interface FeatureExposedEventSenderProps {
  source: string;
  cohort: string;
  flagKey: string;
  attributes: {
    reason?: string;
    experimentName?: string;
    value?: string;
    growthInitiative?: string;
  };
}

/**
 * This component is used to send a GasV3 feature exposed event
 */
export const FeatureExposedEventSender: React.FC<FeatureExposedEventSenderProps> = ({ source, flagKey, cohort, attributes }) => {
  const analyticsClient = useAnalyticsClient();
  const hasSent = useRef(false);

  useEffect(() => {
    if (hasSent.current) {
      return undefined;
    }

    analyticsClient.sendTrackEvent({
      data: {
        action: TrackAction.Exposed,
        actionSubject: TrackActionSubject.Feature,
        source,
        attributes: { ...attributes, flagKey, cohort },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/14797',
    });

    hasSent.current = true;
  }, [analyticsClient, attributes, cohort, flagKey, source]);

  return null;
};
